import { useEffect, useState } from "react";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import { ContractingDetailContent, type DetailTab } from "./ContractingDetailContent";

export function ContractingDetailSheet({
  contractingId,
  searchProfileId,
  locked,
  analyzeOnUnlock,
  open,
  onOpenChange,
  initialTab,
  hideFullScreen,
}: {
  contractingId: number | null;
  searchProfileId?: number;
  /** Pista del llamador: evita el request que daría 403 y abre ya en compacto. */
  locked?: boolean;
  /** Desbloquearla también la cruza: el botón lo dice. */
  analyzeOnUnlock?: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** La pestaña con la que abre. */
  initialTab?: DetailTab;
  /** Sin el enlace a pantalla completa (onboarding). */
  hideFullScreen?: boolean;
}) {
  // Bloqueada = panel de desbloqueo, que en el modal grande queda vacío. La
  // pista del llamador da el tamaño inicial y el contenido lo corrige al
  // resolverse, para que el modal crezca apenas se desbloquea.
  const [isLocked, setIsLocked] = useState(locked === true);
  useEffect(() => {
    if (open) setIsLocked(locked === true);
  }, [open, contractingId, locked]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className={cn(
          "flex w-[95vw] flex-col gap-0 overflow-hidden p-0",
          isLocked
            ? "max-w-md sm:max-w-lg"
            : "max-h-[90vh] max-w-5xl sm:max-w-[90rem]",
        )}
      >
        <DialogTitle className="sr-only">Detalle de licitación</DialogTitle>
        {contractingId != null && (
          <ContractingDetailContent
            contractingId={contractingId}
            searchProfileId={searchProfileId}
            locked={locked}
            analyzeOnUnlock={analyzeOnUnlock}
            onLockedChange={setIsLocked}
            onClose={() => onOpenChange(false)}
            initialTab={initialTab}
            hideFullScreen={hideFullScreen}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
